import React, { useEffect, useState } from 'react';
import {
  Card,
  CardBody,
  CardTitle,
  Table,
  Button,
  Spinner,
  Row,
  Col
} from 'reactstrap';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { connect } from "react-redux";
import { setBreadcrumbItems } from "../../store/actions";
import api, { FILE_BASE_URL } from '../../utils/api';

const JournalistsList = (props) => {
  const [journalists, setJournalists] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    props.setBreadcrumbItems('الصحفيين', [
      { title: "الرئيسية", link: "/dashboard" },
      { title: "الصحفيين", link: "#" }
    ]);
  }, [props]);

  useEffect(() => {
    fetchJournalists();
  }, []);

  const fetchJournalists = async () => {
   try {
     const response = await api.get('/journalists');
      setJournalists(response.data.data);
    } catch (error) {
      console.error('Error fetching journalists:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("هل أنت متأكد من حذف هذا الصحفي؟")) return;
   try {
     await api.delete(`/journalists/${id}`);
      alert("تم حذف الصحفي بنجاح");
      fetchJournalists();
    } catch (error) {
      console.error('فشل حذف الصحفي:', error);
      alert("حدث خطأ أثناء حذف الصحفي");
    }
  };

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <Row className="mb-4">
            <Col md={6}>
              <CardTitle className="h4">قائمة الصحفيين</CardTitle>
            </Col>
            <Col md={6} className="text-end">
              <Link to="/dashboard/journalists/create">
                <Button color="primary">
                  <i className="mdi mdi-plus me-1"></i> إضافة صحفي جديد
                </Button>
              </Link>
            </Col>
          </Row>

          {loading ? (
            <div className="text-center">
              <Spinner color="primary" />
            </div>
          ) : (
            <div className="table-responsive">
              <Table className="table align-middle table-bordered table-striped">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>الاسم الكامل</th>
                    <th>المدينة/المنطقة</th>
                    <th>رقم الجوال</th>
                    <th>البريد الإلكتروني</th>
                    <th style={{width: '200px'}}>إجراءات</th>
                  </tr>
                </thead>
                <tbody>
                  {journalists.length === 0 ? (
                    <tr>
                      <td colSpan="6" className="text-center">لا يوجد صحفيين حالياً</td>
                    </tr>
                  ) : (
                    journalists.map((item, index) => (
                      <tr key={item.id}>
                        <td>{index + 1}</td>
                        <td>{item.full_name}</td>
                        <td>{item.city_or_area || '-'}</td>
                        <td>{item.mobile1 || '-'}</td>
                        <td>{item.email || '-'}</td>
                        <td>
                          <div className="d-flex gap-1">
                            {/* زر العرض الجديد */}
                            <Link to={`/dashboard/journalists/view/${item.id}`}>
                              <Button size="sm" color="success" className="me-1">
                                <i className="mdi mdi-eye me-1"></i>
                                عرض
                              </Button>
                            </Link>
                            
                            <Link to={`/dashboard/journalists/edit/${item.id}`}>
                              <Button size="sm" color="info" className="me-1">
                                <i className="mdi mdi-pencil me-1"></i>
                                تعديل
                              </Button>
                            </Link>

                           <Button
                             size="sm"
                             color="warning"
                             className="me-1"
                             onClick={() => window.open(`/dashboard/journalists/print/${item.id}`, '_blank')}
                           >
                             <i className="mdi mdi-file-pdf me-1"></i>
                             PDF
                           </Button>

                           <Button
                             size="sm"
                             color="secondary"
                             className="me-1"
                             onClick={() => window.open(`/dashboard/journalists/print/${item.id}`, '_blank')}
                           >
                             <i className="mdi mdi-printer me-1"></i>
                             طباعة
                           </Button>                            <Button
                              size="sm"
                              color="danger"
                              onClick={() => handleDelete(item.id)}
                            >
                              <i className="mdi mdi-delete me-1"></i>
                              حذف
                            </Button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            </div>
          )}
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(JournalistsList);